const mainURL = "https://gis-api.nntu-navajo-nsn.org/api/";

export default mainURL;
